// Environment base object
export const baseEnvironment = {
  apiBasePath: 'https://apitest.renaultbank.es',
  applications: {
    home: 'https://test.renaultbank.es',
    onboarding: 'https://registrotest.renaultbank.es/',
    documents: 'https://doctest.renaultbank.es/',
  },
  gtmId: 'GTM-T37F69P',
  // authorization: 'eFh0WmxLNU03bXlRVWtwcWNaakk6RUNVaWxyREduUXRpWGhFQ1lZWTM=',
  authorization: 'YzZ4VVViTTZPZG9oN3FpbEQxRmQ6Y2EzamNzUWZUQ0dCZTF0cVh4M2g=',
  endpoints: {
    authenticate: '/api/v1/services/authenticate',
    activate: '/api/v1/services/activate',
    passwordForgot: '/api/v1/services/client/password/forgot',
    passwordRegeneration: '/api/v1/services/client/private/password/regeneration',
    revoke: '/api/v1/services/revoke',
    case: '/services/apexrest/api/v2/private/case',
    globalposition: '/services/apexrest/api/v1/private/globalposition',
    pendingHirings: '/services/apexrest/api/v1/private/pendingHirings',
    account: '/services/apexrest/api/v1/private/account',
    uploadDocumentCase: '/api/v1/services/minerva/crm/uploadFromIdCase',
    virtualMailbox: {
      checkCorrespondence: '/services/apexrest/api/v1/private/checkCorrespondence',
      getCorrespondence: '/services/apexrest/api/v1/private/getCorrespondence',
    },
    trasactions: {
      get: '/services/apexrest/api/v1/private/getMovements',
      generateOtp: '/api/v1/services/otp/MVP2/generate',
      validateOtp: '/api/v1/services/otp/MVP2/validate',
    },
    transfer: {
      simulate: '/api/v1/services/transfers/sepa/simulate',
      otp: '/api/v1/services/transfers/sepa/otp',
      confirm: '/api/v1/services/transfers/sepa',
    },
    deposit: {
      getImpositions: '/services/apexrest/api/v2/private/impositions',
      createImposition: '/api/v1/services/deposits/impositions',
      refund: '/api/v1/services/deposits/impositions/refund',
      createImpositionOTP: '/api/v1/services/deposits/impositions/otp',
      refundOTP: '/api/v1/services/deposits/impositions/refund/otp',
      newHiring: '/services/apexrest/api/v1/private/newHiring',
      getPdfContract: '/services/apexrest/api/v1/private/getPdfContract',
      getPdfImposition: '/services/apexrest/api/v1/private/getPdfImposition',
      getMinervaImposition: '/api/v1/services/minerva/documents/',
      getRequiredDoc: '/services/apexrest/api/v1/private/getRequiredDoc',
      downloadImpositionConditionDoc: '/api/v1/service/reports/template',
      renewalOtp: '/api/v1/services/deposits/impositions/renewal/otp',
      renewal: '/api/v1/services/deposits/impositions/renewal',
      updateSalesforceImposition: '/services/apexrest/api/v1/private/renovation',
    },
    sign: {
      startSignProcessSubmit: '/services/apexrest/api/v1/private/startSignProcessSubmit',
      startSignProcessBulkSign: '/services/apexrest/api/v1/private/startSignProcessBulkSign',
      querySignProcess: '/services/apexrest/api/v1/private/querySignProcess',
    },
    otp: {
      generate: '/otp/:opId/generate',
      validate: '/otp/:opId/validate',
    },
    documentation: {
      getDocuments: '/api/v1/services/minerva/documents',
      uploadDocuments: '/api/v1/services/minerva/crm/upload',
      getRequestedDocuments: '/services/apexrest/api/v1/utils/documentsbyopportunity',
    },
    personalData: {
      consent: '/services/apexrest/api/v2/private/consent',
    },
  },
  oneTrustKey: '72a36bc5-063c-45c6-9795-a34cf1b3286e-test',
  production: false,
  firebaseAnalyticsDebugMode: false,
  chatbot: {
    siteURL: 'https://renaultbank--uatfull.sandbox.my.site.com/ESWRCIWEBCHAT1741103457124',
    orgIdSF: '00D2z000000658C',
    sdkURL:
      'https://renaultbank--uatfull.sandbox.my.site.com/ESWRCIWEBCHAT1741103457124/assets/js/bootstrap.min.js',
    scrt2URL: 'https://renaultbank--uatfull.sandbox.my.salesforce-scrt.com',
    typeChat: 'RCI_WEB_CHAT',
  },
  mosaic: {
    clientId: 'n_-kIKZs7F685mUnPk0Z3',
    idoServerUrl: 'https://api.eu.transmitsecurity.io/ido',
    drsServerUrl: 'https://api.eu.transmitsecurity.io/risk-collect/',
    journeyName: 'post_login',
    stateExpirationTimeInMilliseconds: 300000,
    sdkUrl: 'https://platform-websdk.transmitsecurity.io/platform-websdk/2.x/ts-platform-websdk.js',
  },
  firebase: {
    apiKey: 'AIzaSyBrK4SaXkX_Gi-lBvpB1eK3Bg7e5p7Ho_8',
    authDomain: 'rci-depositos.firebaseapp.com',
    databaseURL: 'https://rci-depositos.firebaseio.com',
    projectId: 'rci-depositos',
    storageBucket: 'rci-depositos.firebasestorage.app',
    messagingSenderId: '191662910924',
    appId: '1:191662910924:web:f3dc7ac65cf5f840918169',
    measurementId: 'G-8DQFXVK01W',
  },
  remoteConfig: {
    buildFlavorKey: 'build_flavor_test',
  },
};

export type Environment = typeof baseEnvironment;
